module.exports = __webpack_public_path__ + "media/3_2-1.b9a2c0bc.mp3";